<template>

	<div class="inner settings with-tables">
		<div class="headline">
			<h1>{{$t('user.settings.title')}}</h1>
		</div>
		<tabs>
			<tab :name="$t('user.settings.tab.general')">
				<div class="container">
					<div class="intro">
						<h2>{{$t('user.settings.tab.general')}}</h2>
					</div>
					<div class="settings-content">

						<!-- <div class="row">
							<div class="container">
								<div class="info">
									<p class="label">{{ $t('user.settings.logo') }}</p>
									<img v-if="uploadedPicture" :src="uploadedPicture" />
									<button v-if="uploadedPicture" v-on:click="deleteImage()">{{ $t('delete') }}</button>
								 	<vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
						                @vdropzone-success="uploadSuccess"
						                @vdropzone-error="customUploadError"
						                class="dropzone profile-pic"></vue-dropzone>
								</div>
							</div>
						</div> -->

						<div class="row">
							<div class="container" v-if="!nameForm">
								<div class="info">
									<p class="label">{{$t('user.settings.label.name')}}</p>
									<p>{{getFullNameNoFallback}}</p>
								</div>
								<div v-if="!isVerified" class="edit">
									<a class="button purple" @click.prevent="nameForm = !nameForm">{{$t('user.settings.label.edit')}}</a>
								</div>
							</div>
							<form v-else>
								<input type="text" v-model="fullName" autofill="off" autocomplete="false" :placeholder="$t('user.settings.label.name')">
								<button class="button purple" :disabled="!validateName" @click.prevent="updateFullName">{{$t('user.settings.label.save')}}</button>
								<a class="button purple" @click.prevent="nameForm = !nameForm">{{$t('user.settings.label.close')}}</a>
							</form>
						</div>

						<div class="row" v-if="getTenantAccess === null">
							<div class="container" v-if="!companyForm">
								<div class="info">
									<p class="label">{{ $t('user.settings.label.company') }}</p>
									<template v-if="companyName || companyVatNo">
										<p>{{ companyName }} (DK{{ companyVatNo }})</p>
									</template>
									<template v-else>
										{{ $t('user.settings.no-company-created.label') }}
									</template>
								</div>
								<div class="edit">
									<a class="button purple" @click.prevent="companyForm = !companyForm">
										<template v-if="companyName">
											{{$t('user.settings.label.edit')}}
										</template>
										<template v-else>
											{{$t('user.settings.label.create')}}
										</template>
									</a>
								</div>
							</div>
							<div class="container" v-else>
								<form>
									<input type="text" v-model="companyName" :placeholder="$t('user.settings.label.company')">
									<input type="text" v-model="companyVatNo" :placeholder="$t('user.settings.label.vatno')">
									<button class="button purple" @click.prevent="updateCompanyName">{{$t('user.settings.label.save')}}</button>
									<a class="button purple" @click.prevent="companyForm = !companyForm">{{$t('user.settings.label.close')}}</a>
								</form>
							</div>
						</div>

						<div class="row" v-if="getTenantAccess === null">
							<div class="container">
								<div class="image" v-if="uploadedPicture">
									<img :src="uploadedPicture" />
								</div>
								<div class="info" v-if="!uploadedPicture">
									<p class="label">{{ $t('user.settings.label.logo') }}</p>
								</div>
								<div class="info" v-if="uploadedPicture">
									<p class="label">{{ $t('user.settings.label.logo') }}</p>
									<p v-if="uploadedPicture" v-on:click="deleteImage()">{{ $t('user.settings.delete') }}</p>
								</div>
								<div class="edit with-comment" v-if="!uploadedPicture">
									<p class="comment">
										{{ $t('user.settings.logo.upload-comment') }}
									</p>
									<button class="button purple" v-on:click="openLogoUpload()">{{$t('button.label.upload')}}</button>
									<div style="display: none;">
										<vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
						                @vdropzone-success="uploadSuccess"
						                @vdropzone-error="customUploadError"
						                class="dropzone profile-pic"></vue-dropzone>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="container" v-if="!emailForm">
								<div class="info">
									<p class="label">{{$t('user.settings.label.email')}}</p>
									<p>{{getAccountEmail}}</p>
								</div>
								<div class="edit">
									<a class="button purple" @click.prevent="emailForm = !emailForm">{{$t('user.settings.label.edit')}}</a>
								</div>
							</div>
							<form class="container" v-else>
								<input type="text" v-model="email" :placeholder="getEmail" autofill="off" autocomplete="false">
								<input type="password" v-model="emailChangePassword" placeholder="******" autofill="off" autocomplete="false">
								<button class="button purple" :disabled="!validateEmail" @click.prevent="updateEmail">{{$t('user.settings.label.save')}}</button>
								<a class="button purple" @click.prevent="emailForm = !emailForm">{{$t('user.settings.label.close')}}</a>
							</form>
						</div>

						<div class="row" v-for="row in generalSettings">
							<div class="container">
								<div class="info">
									<p class="label">{{	$t(row.label) }}</p>
									<p>{{ row.input }}</p>
								</div>
								<div class="edit">
									<a :href="row.link" class="button purple">{{$t('user.settings.label.edit')}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</tab>
			<!--
			SAVE FOR LATER USE
			<tab :name="$t('user.settings.tab.notifications')">
				<div class="intro">
					<h2>{{$t('user.settings.tab.notifications')}}</h2>
				</div>
				<div class="settings-content">
					<div class="row" v-for="row in notificationSettings">
						<div class="info">
							<p class="label">{{	$t(row.label) }}</p>
							<p>{{ $t(row.text) }}</p>
						</div>
						<div class="edit">
							<label class="switch">
								<input type="checkbox" @click="check(row)" v-model="row.isChecked">
								<div class="slider"></div>
							</label>
						</div>
					</div>
				</div>
			</tab> -->
			<tab :name="$t('user.settings.tab.export.tabname')" v-if="getTenantAccess === null && !hasLimitedAccess">
				<div class="intro">
					<h2>{{$t('user.settings.tab.export.label')}}</h2>
					<p>{{$t('user.settings.tab.export.text')}}</p>
				</div>
				<div class="settings-content">
					<a target="_blank" :href="exportUrl"><button class="purple">{{ $t('user.settings.tab.export.button') }}</button></a>
				</div>
			</tab>
			<tab :name="$t('user.settings.tab.subscription')" v-if="getTenantAccess === null && !hasLimitedAccess">
				<SubscriptionManager mode="full"></SubscriptionManager>
			</tab>
			<tab :name="$t('user.settings.tab.p11.header')" v-if="getTenantAccess === null && !hasLimitedAccess">
				<special-conditions></special-conditions>
			</tab>
			<tab :name="$t('user.settings.tab.emails')" v-if="getTenantAccess === null && !hasLimitedAccess">
				<EmailManager />
			</tab>
			<tab :name="$t('user.settings.tab.deleteaccount')">
				<div class="intro">
					<h2>{{$t('user.settings.tab.deleteaccount')}}</h2>
					<p>{{$t('user.settings.enter-password-to-delete')}}</p>
				</div>
				<div class="settings-content delete-container">
					<div class="row">
						<div class="container">
							<form>
								<input type="password" v-model="passwordToDelete" placeholder="******" style="width:200px;" />
							</form>
						</div>
					</div>
					<button :disabled="deleting" class="purple button" v-on:click="deleteAccount()">{{ $t('user.settings.proceed-with-account-deletion') }}</button>
				</div>
			</tab>
		</tabs>

        <div>
            <p class="version">{{ appVersion }}</p>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue';

    import {ClientTable} from 'vue-tables-2';
    import {mapGetters} from 'vuex';
    import SubscriptionManager from '../../components/SubscriptionManager'
    import CreditCardList from '../../components/Checkout/CreditCardList.vue';
    import EmailManager from '../../components/EmailManager';
    import SpecialConditions from "../../components/settings/SpecialConditions";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    Vue.use(ClientTable);

    export default {
    	data: () => ({
    		creditCardId: '', // CAN DELETE AFTER CC TESTING
    		companyName: '',
    		companyVatNo: '',
    		uploadedPicture: '',
    		dropzoneOptions: {},
    		passwordToDelete: '',
    		deleting: false,
    		exporting: false,
			nameForm: false,
			companyForm: false,
			fullName:'',
			emailForm: false,
			email:'',
			emailChangePassword: '',
    		checked: [],
    		generalSettings: [
    			{
    				info: 'password',
    				label: 'login.form.password',
    				input: '******************',
    				link: '/user/change-password'
    			}
    		],

    		notificationSettings: [
    			{
    				info: 'email',
    				label: 'email',
    				text: 'notification.settings.by-email',
    				isChecked: true
    			}
    		],
            appVersion: window.config.version,
            power_supply_enabled: true
    	}),
    	components: {
    		SubscriptionManager,
    		EmailManager,
            vueDropzone: vue2Dropzone,
            CreditCardList,
			SpecialConditions
    	},
		computed: {
			...mapGetters([
			    'getFullNameNoFallback',
				'getToken',
				'getEmail',
				'getAccountEmail',
				'isVerified',
				'hasLimitedAccess',
                'getTenantAccess',
                'getSimplexEnabled'
			]),
            validateEmail(){
                return this.validEmail(this.email);
            },
			validateName(){
                return this.fullName !== '';
			},
			exportUrl() {
				return window.config.apiUrl + 'export?token=' + this.getToken;
			}
		},
		created() {
			this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/company/logo',
                thumbnailWidth: 150,
                maxFilesize: 10,
                paramName: 'image',
				headers: {
					'Authorization': 'Bearer ' + this.getToken
				},
                autoProcessQueue: true,
                dictDefaultMessage: 'Drop files here to upload or click to browse',
                dictFileTooBig: 'File is too big',
                uploadMultiple: false,
                acceptedFiles: 'image/*',
                error: function(file, error) {
                    this.$swal(error.message, [], 'error');
                    this.removeAllFiles();
                }
            };
			this.$store.dispatch('fetchUserData').then(() => {this.power_supply_enabled = this.getSimplexEnabled});
			this.loadLogo();
			this.loadCompany();
		},
    	methods: {
            submit: function () {
                axios({
                    method: 'POST',

                    url: window.config.apiUrl + 'api/user/settings',
                    data: {
                        power_supply_enabled : this.power_supply_enabled,
                    }
                }).then(response => {
                    this.$store.commit('setSuccessBarMessage', this.$t('user.settings.tab.p11.success'));
                    this.$store.commit('setSimplexEnabled', this.power_supply_enabled);
                }).finally(() => {
                    this.loading = false;
                });
            },
    		openLogoUpload() {
    			document.getElementById('dropzone').click();
    		},
    		loadCompany() {

	    			axios({
	                    method: 'GET',

	                    url: window.config.apiUrl + 'api/company'
	                }).then(response => {
	                	this.companyName = response.data.name;
	                	this.companyVatNo = response.data.vatNo;
	                });
    		},
    		loadLogo() {

	    			axios({
	                    method: 'GET',

	                    url: window.config.apiUrl + 'api/company/logo'
	                }).then(response => {
	                	this.uploadedPicture = response.data.logoUrl;
	                });

    		},
    		customUploadError(data) {
                if(data.xhr !== null && (data.xhr.status === 401 || data.xhr.status === 403)) {
                    this.$store.commit('setToken', null)
                    return;
                }

                if (typeof data.xhr == 'undefined') {
                    this.$swal(this.$t('general.unknown-error.label'), [], 'error');
                    return;
                }
                let response = JSON.parse(data.xhr.responseText);
                this.$swal(this.$t(response.message), [], 'error');
            },
            uploadSuccess(file, response){
                this.loadLogo();
            },
            deleteImage(){
            	if (!confirm(this.$t('user.settings.delete-logo.confirm'))) {
            		return;
            	}
                axios({
                    method: 'DELETE',
                    url: window.config.apiUrl + 'api/company/logo',

                }).then(response => {
                    this.loadLogo();
                });
            },
    		deleteAccount() {
    			if (confirm(this.$t('user.settings.delete-account-are-you-sure'))) {
    				this.deleting = true;
    				axios({
	                    method: 'DELETE',

	                    url: window.config.apiUrl + 'api/user',
	                    data: {
	                    	password: this.passwordToDelete
	                    }
	                }).then(response => {
	                	this.$store.dispatch('logout');
						this.$router.push('/login');
						this.$router.go(0);
	                }).finally((e) => {
    					this.deleting = false;
	                });
    			}
    		},
    		check(row){
                row.isChecked = !row.isChecked
            },
            updateFullName(){
                axios({
                    method: 'POST',

                    url: window.config.apiUrl + 'api/user/name/update',
					data:{
                        full_name: this.fullName
					}
                }).then(response => {
                    this.$store.commit('setFullName', this.fullName);
                    this.nameForm = false;
                });
			},
            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
    		updateCompanyName() {
                axios({
                    method: 'PATCH',

                    url: window.config.apiUrl + 'api/company',
                    data:{
                        name: this.companyName,
                        vatNo: this.companyVatNo
                    }
                }).then(response => {
                	this.$store.commit('setSuccessBarMessage', this.$t('saved'));
                	this.companyForm = false;
                });
    		},
            updateEmail(){
                axios({
                    method: 'POST',

                    url: window.config.apiUrl + 'api/user/email/update',
                    data:{
                        email: this.email,
                        password: this.emailChangePassword
                    }
                }).then(response => {
                    this.$store.commit('setEmail', this.email);
                    this.emailForm = false;
                });
            }
    	}
    }

</script>
<style scoped>

.version {
    color: #808080;
    font-family: HankenGroteskRegular, HankenGroteskRegularOld, HelveticaNeue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin: 15px 5px;
    text-align: right;
}

</style>
